import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { LIST_LIMIT_MAX } from '../../../core/constants/network';
import { normalizeAttention } from '../../../common/package/activity';
import { normalizeList } from '../../../common/package/list';
import { normalizeSeat } from '../../../common/package/seat';
import { coordinationKeys } from '../work/keys';
import { coordinationPaths } from '../work/paths';

const LIVE_REFRESH_MS = 30_000;

export function useSeats() {
    const params = { limit: LIST_LIMIT_MAX };
    return useQuery({
        queryKey: coordinationKeys.seats(params),
        queryFn: async ({ signal }) => normalizeList((await api.get(coordinationPaths.seats(), { params, signal })).data, normalizeSeat),
        refetchInterval: LIVE_REFRESH_MS,
    });
}

export function useAttention() {
    const params = { limit: 50 };
    return useQuery({
        queryKey: coordinationKeys.attention(params),
        queryFn: async ({ signal }) => normalizeList((await api.get(coordinationPaths.attention(), { params, signal })).data, normalizeAttention),
        refetchInterval: LIVE_REFRESH_MS,
    });
}
